import { render } from "./KitDataTable.vue?vue&type=template&id=2b3170d1&scoped=true"
import script from "./KitDataTable.vue?vue&type=script&lang=js"
export * from "./KitDataTable.vue?vue&type=script&lang=js"

import "./KitDataTable.vue?vue&type=style&index=0&id=2b3170d1&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3170d1"]])

export default __exports__